export default __webpack_public_path__ + "static/media/img-14.8fffd77f.jpg";